import { Component, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AlertComponent, ButtonComponent, InputComponent } from '@verticalbridge/ui-components';
import { PortalAuthService } from '../../core/auth/portal-auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthLayoutComponent } from '../../shared/components/auth-layout/auth-layout.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    AuthLayoutComponent,
    AlertComponent,
    ButtonComponent,
    InputComponent,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  private authService = inject(PortalAuthService);
  private destroyRef = inject(DestroyRef);
  protected router = inject(Router);

  email = '';
  isLoading = false;
  isSubmitted = false;
  errorMessage = '';
  currentYear = new Date().getFullYear();

  submitResetRequest() {
    if (!this.email) {
      this.errorMessage = 'Please enter your email address';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.authService.requestPasswordReset(this.email).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: () => {
        this.isLoading = false;
        this.isSubmitted = true;
      },
      error: () => {
        this.isLoading = false;
        // Show success message even on error to prevent email enumeration
        this.isSubmitted = true;
      }
    });
  }
}
